import { ConfirmDialog } from '@molecules/ConfirmDialog';
import { createContext, useContext, useState } from 'react';

const ConfirmDialogContext = createContext({
  openConfirmDialog: ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    title,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    description,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    callback,
  }: {
    title: string;
    description?: string;
    confirmBtnTitle?: string;
    closeBtnTitle?: string;
    callback?: () => void;
    onClose?: () => void;
  }) => {},
});

export function ConfirmDialogContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [dialogData, setDialogData] = useState<{
    title: string;
    description?: string;
    confirmBtnTitle?: string;
    closeBtnTitle?: string;
    open: boolean;
    callback?: () => void;
    onClose?: () => void;
  }>({
    title: '',
    description: '',
    confirmBtnTitle: '확인',
    closeBtnTitle: '취소',
    open: false,
    callback: () => {},
    onClose: () => {},
  });

  const openConfirmDialog = ({
    title,
    description,
    confirmBtnTitle,
    closeBtnTitle,
    callback = () => {},
    onClose = () => {},
  }: {
    title: string;
    description?: string;
    confirmBtnTitle?: string;
    closeBtnTitle?: string;
    callback?: () => void;
    onClose?: () => void;
  }) => {
    setDialogData({
      title,
      description,
      confirmBtnTitle,
      closeBtnTitle,
      open: true,
      callback,
      onClose,
    });
  };

  const handleCallback = () => {
    setDialogData({
      ...dialogData,
      open: false,
    });
    if (dialogData.callback) dialogData.callback();
  };

  const handleClose = () => {
    setDialogData({
      ...dialogData,
      open: false,
    });
    if (dialogData.onClose) dialogData.onClose();
  };

  return (
    <ConfirmDialogContext.Provider
      value={{
        openConfirmDialog,
      }}
    >
      <ConfirmDialog
        title={dialogData.title}
        description={dialogData.description}
        open={dialogData.open}
        confirmBtnTitle={dialogData.confirmBtnTitle}
        closeBtnTitle={dialogData.closeBtnTitle}
        callback={handleCallback}
        onClose={handleClose}
      />
      {children}
    </ConfirmDialogContext.Provider>
  );
}

export function useConfirmDialog() {
  return useContext(ConfirmDialogContext);
}
